import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Badge } from '../../material-ui/Badge';
import { Notice } from '../../../icons';
import { useNotice } from './useNotice';
import { useStyles } from './useStyles';

export const NoticeAdapter = memo(({ value, selected, onClick, className }) => {
    const { isNoticeAllowed, isNotices, recent } = useNotice();

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick]);

    if (!isNoticeAllowed) {
        return null;
    }

    return (
        <ListItem onClick={handleClick} button={true} disabled={!isNotices} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Badge badgeContent={recent} color="secondary" max={999} classes={{ anchorOriginTopRightRectangular: classes.badge }}>
                    <Notice width="24" height="24" />
                </Badge>
            </ListItemIcon>
            <ListItemText primary={translate('labels.notice')} className={className} />
        </ListItem>
    );
});

NoticeAdapter.displayName = 'NoticeAdapter';
